// src/services/historyService.js
import api from './api';
import { getToken } from './auth';


// Update the getHistories function to accept query parameters:
export const getHistories = async (page = 1, limit = 10, queryParams = '') => {
  try {
    const response = await api.get(`/histories?page=${page}&limit=${limit}&${queryParams}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching histories:', error);
    throw error;
  }
};

// Get a specific history by ID
export const getHistoryById = async (id) => {
  try {
    const response = await api.get(`/histories/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching history details:', error);
    throw error;
  }
};

// Get statistics
export const getStatistics = async () => {
  try {
    const response = await api.get('/histories/stats');
    return response.data;
  } catch (error) {
    console.error('Error fetching statistics:', error);
    throw error;
  }
};

// Export history to PDF
export const exportToPdf = async (historyId) => {
  try {
    const response = await api.get(`/histories/${historyId}/export`, {
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `VirtualMedic_Report_${historyId}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error exporting PDF:', error);
    console.error('Error response:', error.response);
    if (error.response?.status === 401) {
      throw new Error('Authentication required. Please log in again.');
    } else if (error.response?.status === 404) {
      throw new Error('History not found.');
    } else if (error.response?.status === 500) {
      throw new Error('Server error while generating PDF. Please try again.');
    }
    throw error;
  }
};